import React from 'react';
import { Table, Tag, Badge } from 'antd';
import { useSelector } from 'react-redux';
import moment from 'moment';

const TradesTable = ({ trades, loading }) => {
  const brokersList = useSelector((state) => state?.brokers?.list || []);
  const getBrokerLabel = (id) => {
    const b = (brokersList || []).find(x => (x?.id?.toString?.() || '') === id?.toString?.());
    if (!b) return id;
    return b?.name?.toUpperCase() || `${b?.type?.toUpperCase?.()} - ${b?.userName?.toUpperCase?.()}` || id;
  };
  const tradeColumns = [
    {
      title: 'Symbol',
      align: 'left',
      dataIndex: ['tradingSymbol'],
      key: 'symbol',
      width: '20%',
      ellipsis: true,
    },
    {
      title: 'Broker',
      dataIndex: 'brokerId',
      key: 'broker',
      width: '20%',
      align: 'center',
      render: (brokerId) => (
        <Tag color="purple">{getBrokerLabel(brokerId)}</Tag>
      ),
    },
    {
      title: 'Type',
      dataIndex: 'transactionType',
      key: 'type',
      width: '10%',
      align: 'center',
      render: (type) => (
        <Badge 
          color={type === 'BUY' ? 'green' : 'red'} 
          text={type} 
        />
      ),
    },
    {
      title: 'Qty',
      dataIndex: 'quantity',
      key: 'quantity',
      width: '10%',
      align: 'right',
    },
    {
      title: 'Price',
      dataIndex: 'averagePrice',
      key: 'price',
      width: '15%',
      align: 'right',
      render: (price) => price ? Number(price).toFixed(2) : '-',
    },
    {
      title: 'Time',
      dataIndex: 'fillTime',
      key: 'time',
      width: '10%',
      align: 'center',
      render: (timestamp) => timestamp ? moment(timestamp).format('HH:mm:ss') : '-',
    },
  ];

  return (
    <div style={{ width: '50vw', overflow: 'hidden' }}>
      <Table
        columns={tradeColumns}
        dataSource={trades}
        rowKey="id"
        loading={loading}
        pagination={false}
        size="small"
        scroll={{ x: true }}
        locale={{ emptyText: 'No trades found' }}
        style={{ width: '100%' }}
        tableLayout="fixed"
      />
    </div>
  );
};

export default TradesTable;
